import React, { Component } from 'react'
import NProgress from 'nprogress'

import Grid from '../Grid';

import Train from '../../services/train.js';

class Tags extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      tags: []
    }
  }

  componentDidMount() {
    this.fetchData(1);
  } 

  componentWillReceiveProps(newProps) {
  }

  fetchData(page) {
    NProgress.start();

    Train.fetchTopTags()
    .then((data) => {
      this.setState({
        tags: this.state.tags.concat(data)
      });
      NProgress.done();
    });
  }

  loadMore() {
    if (this.state.hasMore) {
      this.fetchData()
    }
  }

  render() {

    return (

      <div className="infinite">
        <Grid title="Tags" type="tag" elements={this.state.tags} />
      </div>

    );

  }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/js/components/explore/Tags.jsx